import React, { useRef, useEffect, useState } from 'react'

import { getProveedoresActivos } from '../../../../../API/Proveedores/ProveedoresRequests';

// Componentes PrimeReact
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputText } from 'primereact/inputtext';
import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid';

const ProductosOverlayPanel = ({ rowData, close, onChange }) => {

    const op = useRef(null);
    const buttom = useRef(null)
    const [loading, setLoading] = useState(false);
    const [proveedoresActivos, setProveedoresActivos] = useState([]);


    const obtenerProductosActivos = async () => {
        setLoading(true);
        const tempo = await getProveedoresActivos();
        setProveedoresActivos(tempo);
        setLoading(false)
    }


    const table = {
        Columns: [
            {
                header: 'CustomerName',
                field: 'CustomerName',
                flex: 1,
            },
        ],
        Data: proveedoresActivos,
        onCellClicked: e => onChange(e, rowData),
        loading: loading,

    }


    useEffect(() => {
        obtenerProductosActivos();
    }, [])
    


    return (
        <React.Fragment>

            <div className="p-inputgroup">
                <InputText value={rowData.Proveedor} disabled placeholder="Proveedor" onClick={(e) => op.current.toggle(e)} />
                <Button ref={buttom} icon='pi pi-angle-down' style={{ padding: '0.5rem 0.3rem' }} type="button" onClick={(e) => op.current.toggle(e)} />
            </div>
            <OverlayPanel ref={op} showCloseIcon dismissable={false} className='OverPanelProveedor' onHide={close}>
                <div style={{ width: 500, height: 300 }}>
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>
        </React.Fragment>
    )
}

export default ProductosOverlayPanel;
